var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 44V22C27.5 18.975 29.9475 16.5 33 16.5H57.75V13.75C57.75 10.725 55.275 8.25 52.25 8.25H13.75C10.6975 8.25 8.25 10.725 8.25 13.75V52.25C8.25 55.275 10.6975 57.75 13.75 57.75H52.25C55.275 57.75 57.75 55.275 57.75 52.25V49.5H33C29.9475 49.5 27.5 47.025 27.5 44ZM35.75 22C34.2375 22 33 23.2375 33 24.75V41.25C33 42.7625 34.2375 44 35.75 44H60.5V22H35.75ZM44 37.125C41.7175 37.125 39.875 35.2825 39.875 33C39.875 30.7175 41.7175 28.875 44 28.875C46.2825 28.875 48.125 30.7175 48.125 33C48.125 35.2825 46.2825 37.125 44 37.125Z",
    fill: "#FFDE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.b8f5c87ab373e9b501682105e5f75a3d.svg";
export { ForwardRef as ReactComponent };